import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { defaultWellnessFormValues, WellnessFormValues } from "./WellnessFormValues";
import { Language } from "../enums/Language";
import { Taxation } from "../enums/Taxation";

export type WellnessEmployeeFormValues = EmployeeFormValues & WellnessFormValues & {
    textPermission: boolean,
    preferredLanguage: Language,
    otherLanguage: string,
    dependents: string,
    claimDates: [{
        startDate: string
    }],
    premiumTaxation: Taxation,
    employeeContributionPercentage: string,
    activelyAtWork: boolean,
    dateLastWorked: string,
    facilityName: string,
    facilityPhoneNumber: string,
}

export const defaultWellnessEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultWellnessFormValues,
    textPermission: false,
    preferredLanguage: Language.ENGLISH,
    otherLanguage: '',
    dependents: '',
    claimDates: [{
        startDate: ''
    }],
    premiumTaxation: '',
    employeeContributionPercentage: '',
    activelyAtWork: true,
    dateLastWorked: '',
    facilityName: '',
    facilityPhoneNumber: '',
}